import { render, staticRenderFns } from "./ZonesEdit.vue?vue&type=template&id=07bcf54e"
import script from "./ZonesEdit.vue?vue&type=script&lang=js"
export * from "./ZonesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports